"use strict";

exports.__esModule = true;
exports.default = void 0;
var Zindex = {
  MODAL: '9999',
  OVERLAY: '8000',
  HIGH: '7000',
  MEDIUM: '6000',
  LOW: '-1000'
};
/** @component */

var _default = Zindex;
exports.default = _default;